'use strict'
var sysConfig = {
    //sso address
    //casServerUrl: "http://localhost:8080/cas",
    //frontend address
    //sysDomain: "http://localhost:8080/"

    casServerUrl: "http://sfrz.zepc.edu.cn/cas",
    //frontend address
    sysDomain: "http://ksxt.zepc.edu.cn"
}
module.exports = sysConfig